"use strict";

exports.__esModule = true;
exports.default = void 0;
var gtmListener = function gtmListener(event, data) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(Object.assign({
    event: event
  }, data));
};
var _default = exports.default = gtmListener;